module.exports = __webpack_public_path__ + "img/logo.f339ab04.jpg";